export const PHONE_REGEX = /^\d{10}$/;
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const MATCH_ALPHABETIC = /^[a-zA-Z].*/;
export const SHEET_API_URL =
  "https://script.google.com/macros/s/AKfycbxYWOVDOjlwWC8usF3iHkthiV5zJhBn0J1TefaV8XClqL5i7malnIY9eA2IdVdxL26M6Q/exec";


